import useAPI from '@/hooks/useAPI';
import ReferralRepository from '@/repositories/ReferralRepository';
import { QueryParams } from '@/types/query';

const useReferralsForPersonQuery = (enabled = true, params?: QueryParams) => {
  const repository = ReferralRepository();

  return useAPI({
    queryKey: ['getReferralsForPerson', params],
    queryFn: async () => {
      return await repository.getReferralsForPerson(params);
    },
    enabled
  });
};

export default useReferralsForPersonQuery;
